import React, { Component } from 'react';
import { Modal } from 'antd-mobile';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import styles from '../pay.module.less';

const propTypes = {
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  specification: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
  visible: PropTypes.bool.isRequired,
};

/**
 * 选择商品类型
 */
class ProductSelectModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: {},
      buyNumber: 1,
    };
  }

  handleSelectTab = (item) => () => {
    this.setState({ selectedType: item });
  };

  /**
   * 确定购买
   */
  handleBuy = () => {
    const { onSubmit } = this.props;
    const { selectedType, buyNumber } = this.state;

    if (JSON.stringify(selectedType) === '{}') return false;

    const { id } = selectedType;
    onSubmit(id, buyNumber);
    return true;
  };

  handleLessNumber = () => {
    const { buyNumber } = this.state;
    const newNumber = buyNumber - 1 < 1 ? 1 : buyNumber - 1;
    this.setState({ buyNumber: newNumber });
  };

  handleAddNumber = () => {
    const { buyNumber } = this.state;
    this.setState({ buyNumber: buyNumber + 1 });
  }

  renderProductType = () => {
    const { specification } = this.props;
    const { selectedType } = this.state;

    if (specification && specification.length) {
      return specification.map((item) => {
        const { name, id } = item;
        const activeStyle = selectedType.id === id
          ? ClassNames(styles.productTypeActive, styles.productTypeDefault)
          : styles.productTypeDefault;
        const showName = name ? name.replace(/(.{10}).*/, '$1...') : '';

        return (
          <span
            className={activeStyle}
            key={id}
            onClick={this.handleSelectTab(item)}
            role="button"
            tabIndex={0}
          >
            {showName}
          </span>
        );
      });
    }
    return true;
  };

  render() {
    const { visible, close } = this.props;
    const { selectedType, buyNumber } = this.state;

    return (
      <Modal
        popup
        visible={visible}
        animationType="slide-up"
        className={styles.modalContentRadius}
        maskClosable
        onClose={close}
      >
        <div className={styles.productModalContent}>
          <p className={styles.boldFont}>商品规格</p>
          <div className={styles.productContent}>
            {this.renderProductType()}
          </div>
          {selectedType.name && (
            <div className={styles.selectedProduct}>
              {`已选"${selectedType.name}"`}
            </div>
          )}
        </div>
        <div className={styles.footerBox}>
          <span className={styles.boldFont}>合计：</span>
          <span className={styles.money}>
            ¥
            {Math.floor((selectedType.price / 100) * buyNumber * 100) / 100
              || 0}
          </span>
          <span className={styles.buyButton} onClick={this.handleBuy} role="button" tabIndex={0}>
            {' '}
            确认购买
            {' '}
          </span>
        </div>
      </Modal>
    );
  }
}

ProductSelectModal.propTypes = propTypes;

export default ProductSelectModal;
